//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/UserDefinedTemplate.js";
import "../no/Builder.js";
let d=[[[0,"ConfigurableObject",1,"UserDefinedTemplate.ConfigurableObject",0],[0,"CreatingDeformation",1,0]],[[["objects"],"SetObjects",{},1,0],[["num_objects"],"GetObjects",{R_:{objects:"NXObject[]"}},0,0],[["objects"],"AddObjects",{},1,0],[["objects"],"RemoveObjects",{},1,0],[["entity","isVisble"],"SetObjectVisibility",{},2,0],[["expressions"],"AddEditableExpressions",{},1,0],[["expressions"],"RemoveEditableExpressions",{},1,0],[["num_expressions"],"GetEditableExpressions",{R_:{expressions:"Expression[]"}},0,0],[["num_references"],"GetReferences",{R_:{references:"NXObject[]"}},0,0]],[]];
SPLM.UserDefinedTemplate.DefinitionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.UserDefinedTemplate.DefinitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;